import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";

export default function Navbar() {
 
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const navItems = [
    { name: "HOME", link: "home" },
    { name: "ABOUT US", link: "about" },
    { name: "OUR APPROACH", link: "approach" },
    { name: "CONDITIONS", link: "conditions" },
    { name: "MISSION", link: "mission" },
    /* { name: "BLOG", link: "blog" }, */
    { name: "CONTACT", link: "footer" }
  ];

  // Add shadow on scroll
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="nav-container">

        {/* LOGO */}
        <div className="logo">
          Aeterna<span>HomeoHealth</span>
        </div>

        {/* NAV LINKS */}
        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          {navItems.map((item, index) => (
            <Link
              key={index}
              to={item.link}
              smooth={true}
              duration={500}
              offset={-80}
              spy={true}
              activeClass="active-link"
              className="nav-item"
              onClick={() => setMenuOpen(false)}
            >
              {item.name}
            </Link>
          ))}

          {/* CTA BUTTON */}
          <Link
            to="appointment"
            smooth={true}
            duration={500}
            offset={-80}
            className="appointment-btn"
            onClick={() => setMenuOpen(false)}
          >
            BOOK APPOINTMENT
          </Link>
        </div>

        {/* HAMBURGER */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

      </div>
    </header>
  );
}